


































































































import mixins from 'vue-typed-mixins';
import filters from './filters';
import EmailUtils, {
  AutomatedEmailParams,
  AutomatedEmail,
  AutomatedEmailSummary,
} from '@/utils/EmailUtils';
import cloneDeep from 'lodash.clonedeep';

interface EmailFilter {
  title: string;
  content: 'provider' | 'role' | 'survey';
}

export default mixins().extend({
  components: {
    ...filters,
  },

  computed: {
    filters(): EmailFilter[] {
      // if (this.email) {
      //   if (this.email.type === 'survey') {
      return [
        {
          title: this.$tc('model.survey.label', 2),
          content: 'survey',
        },
        {
          title: this.$tc('model.serviceProvider.label', 2),
          content: 'provider',
        },
        {
          title: this.$tc('model.role.label', 2),
          content: 'role',
        },
      ];
      //   }
      //   if (this.email.type === 'user') {
      //     return [
      //       {
      //         title: 'ROLE',
      //         content: 'role',
      //       },
      //     ];
      //   }
      //   if (this.email.type === 'organization') {
      //     return [
      //       {
      //         title: 'PROVIDER',
      //         content: 'provider',
      //       },
      //     ];
      //   }
      // }
      // return [];
    },
  },

  data(): {
    params: AutomatedEmailParams;
    email?: AutomatedEmail;
    step: number;
    valid: boolean;
    summary?: AutomatedEmailSummary;
    multiLingual: boolean;
  } {
    return {
      params: EmailUtils.generateAutomatedEmailParams(),
      email: undefined,
      step: 0,
      valid: false,
      summary: undefined,
      multiLingual:false,
    };
  },

  watch: {
    async step(nextStep, previousStep) {
      if (nextStep < previousStep) {
        this.valid = true; // going back the previous step should still be valid still
      }
      if (nextStep === this.filters.length) {
        try {
          (this.$refs.alert as any).hide('summary');
          this.summary = undefined;
          this.summary = await EmailUtils.api.summary(this.params);
        } catch (error) {
          (this.$refs.alert as any).show('summary', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },

  methods: {
    async send(test: boolean) {
      try {
        (this.$refs.alert as any).hide('send');
        await EmailUtils.api.send(this.params, test,this.multiLingual);
        if (!test) {
          this.$toast.push({
            type: 'success',
            text: this.$languageobj(
              'page.automatedEmails.send.validation.success'
            ),
          });
          (this.$refs.modal as any).resolve();
          this.clear();
        } else {
          this.$toast.push({
            type: 'success',
            text: this.$languageobj(
              'page.automatedEmails.send.validation.test'
            ),
          });
        }
      } catch (error) {
        (this.$refs.alert as any).show('send', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async cancel() {
      (this.$refs.modal as any).resolve();
      this.clear();
    },

    clear() {
      this.params = EmailUtils.generateAutomatedEmailParams();
      this.email = undefined;
      this.step = 0;
    },

    open(email: AutomatedEmail, params?: Partial<AutomatedEmailParams>) {
      this.params = params
        ? cloneDeep(params)
        : EmailUtils.generateAutomatedEmailParams(email);
      this.email = email;
      (this.$refs.modal as any).open();
    },
  },
});
